// Mock data for techAuriga website

export const heroData = {
  title: "Transform Your Business with AI Innovation",
  subtitle: "techAuriga delivers cutting-edge AI solutions and software services that drive digital transformation",
  cta1: "Get Started",
  cta2: "Learn More",
  heroImage: "https://images.unsplash.com/photo-1672581437674-3186b17b405a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxmdXR1cmlzdGljJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NzU1ODI0MTJ8MA&ixlib=rb-4.1.0&q=85",
  backgroundAlt: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc3NTU0NDQyMHww&ixlib=rb-4.1.0&q=85"
};

export const aboutData = {
  title: "Our Commitment",
  subtitle: "Building Solutions That Drive Success",
  description: "At techAuriga, we're not just coders, we're problem-solvers. Our engineers design customer-focused, cloud-based AI solutions that boost profitability, streamline workflows, and scale with your business.",
  mission: "We serve clients in the USA, UK, Australia, and India with 24/7 availability for software support, app development, AI tools, machine learning, and automation consulting.",
  commitments: [
    {
      title: "Client Success",
      icon: "Target",
      description: "Your success is our priority. We deliver solutions that drive measurable business outcomes."
    },
    {
      title: "Quality",
      icon: "Award",
      description: "Excellence in every line of code. We maintain the highest standards in software development."
    },
    {
      title: "Business Continuity",
      icon: "TrendingUp",
      description: "24/7 support across global time zones ensuring your operations never stop."
    },
    {
      title: "Security",
      icon: "Shield",
      description: "Enterprise-grade security protecting your data and infrastructure at every level."
    }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Machine Learning Solutions",
    description: "Custom ML models tailored to your business needs. We develop intelligent algorithms that learn from your data, providing predictive insights and automation capabilities.",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4",
    features: ["Predictive Analytics", "Custom Model Development", "Model Training & Optimization", "Real-time Inference"]
  },
  {
    id: 2,
    title: "Azure AI Models",
    description: "Leverage Microsoft Azure's powerful AI capabilities with our expert implementation services. We integrate Azure Cognitive Services, OpenAI models, and custom solutions.",
    icon: "Cloud",
    image: "https://images.unsplash.com/photo-1557562645-4eee56b29bc1",
    features: ["Azure OpenAI Integration", "Cognitive Services", "Azure ML Pipelines", "Scalable AI Infrastructure"]
  },
  {
    id: 3,
    title: "Microsoft Fabric",
    description: "Unified analytics platform solutions using Microsoft Fabric. We help you consolidate data, analytics, and AI workloads into a single, powerful ecosystem.",
    icon: "Database",
    image: "https://images.unsplash.com/photo-1644088379091-d574269d422f",
    features: ["Data Integration", "Real-time Analytics", "Data Warehousing", "Power BI Integration"]
  },
  {
    id: 4,
    title: "AI Consulting & Strategy",
    description: "Strategic guidance for your AI transformation journey. Our experts help you identify opportunities, design solutions, and implement AI-driven innovations.",
    icon: "Lightbulb",
    image: "https://images.pexels.com/photos/6019019/pexels-photo-6019019.jpeg",
    features: ["AI Readiness Assessment", "Technology Roadmap", "Use Case Identification", "ROI Analysis"]
  }
];

export const productsData = [
  {
    id: 1,
    title: "AI Analytics Platform",
    description: "Comprehensive analytics platform powered by AI for real-time business insights, predictive modeling, and automated reporting.",
    image: "https://images.unsplash.com/photo-1690627931320-16ac56eb2588?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxjbG91ZCUyMGNvbXB1dGluZ3xlbnwwfHx8fDE3NzU2MDgxMTh8MA&ixlib=rb-4.1.0&q=85",
    features: ["Real-time Dashboards", "Predictive Analytics", "Automated Insights", "Custom Reports"],
    category: "Analytics"
  },
  {
    id: 2,
    title: "Intelligent Automation Suite",
    description: "End-to-end automation solution using AI and ML to streamline business processes, reduce costs, and increase operational efficiency.",
    image: "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc3NTYwODEyNnww&ixlib=rb-4.1.0&q=85",
    features: ["Process Automation", "Smart Workflows", "Document Processing", "RPA Integration"],
    category: "Automation"
  },
  {
    id: 3,
    title: "Cloud AI Infrastructure",
    description: "Scalable, secure cloud infrastructure optimized for AI workloads with seamless Azure integration and enterprise-grade performance.",
    image: "https://images.unsplash.com/photo-1584949091598-c31daaaa4aa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc1NjA4MTIyfDA&ixlib=rb-4.1.0&q=85",
    features: ["Azure Integration", "Auto-scaling", "Security & Compliance", "Monitoring & Analytics"],
    category: "Infrastructure"
  },
  {
    id: 4,
    title: "AI Document Service",
    description: "Transform your document workflows with intelligent automation. Extract, process, and manage documents using advanced AI-powered OCR and data extraction technology.",
    image: "https://images.unsplash.com/photo-1658142034594-12b5c411069d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxkb2N1bWVudCUyMHNjYW5uaW5nJTIwYXV0b21hdGlvbiUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc2MTAxMzgzfDA&ixlib=rb-4.1.0&q=85",
    features: ["AI Document Automation", "Document Data Extraction", "Intelligent Document Processing", "AI OCR Service", "Document Workflow Automation"],
    category: "Document AI"
  },
  {
    id: 5,
    title: "AI Medical Coding Service",
    description: "Revolutionize healthcare billing with autonomous AI-powered medical coding. Automate ICD-10 coding, reduce errors, and accelerate revenue cycles for healthcare providers.",
    image: "https://images.unsplash.com/photo-1758691462848-ba1e929da259?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxtZWRpY2FsJTIwaGVhbHRoY2FyZSUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc2MTAxMzgzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Medical Coding Automation", "AI Medical Billing and Coding", "ICD-10 Coding Automation", "Healthcare Coding Services", "Autonomous Coding Solution"],
    category: "Healthcare AI"
  },
  {
    id: 6,
    title: "AI Blind Assistant Service",
    description: "Empowering independence through AI-driven assistive technology. Provide voice-guided assistance, intelligent screen reading, and accessibility solutions for visually impaired users.",
    image: "https://images.unsplash.com/photo-1767652457496-b933c31fd465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxhc3Npc3RpdmUlMjB0ZWNobm9sb2d5JTIwYWNjZXNzaWJpbGl0eXxlbnwwfHx8fDE3NzYxMDEzODN8MA&ixlib=rb-4.1.0&q=85",
    features: ["Blind Assistance AI", "AI Assistive Technology", "Accessibility AI Service", "Screen Reading Automation", "Voice-Guided Assistance Solution"],
    category: "Accessibility AI"
  }
];

export const contactData = {
  title: "Get In Touch",
  subtitle: "Ready to Transform Your Business?",
  description: "Contact us to discuss how techAuriga can help accelerate your AI transformation journey.",
  email: "info@techauriga.com",
  phone: "+1 (555) 123-4567",
  locations: [
    {
      city: "Denver",
      state: "Colorado",
      coordinates: { lat: 39.7392, lng: -104.9903 }
    },
    {
      city: "Austin",
      state: "Texas",
      coordinates: { lat: 30.2672, lng: -97.7431 }
    }
  ]
};

export const footerData = {
  company: {
    name: "techAuriga",
    description: "Leading AI-based software company delivering innovative products and services worldwide.",
    address: "123 Tech Boulevard, Silicon Valley, CA 94025",
    phone: "+1 (555) 123-4567",
    email: "info@techauriga.com"
  },
  links: {
    company: [
      { name: "About Us", href: "#about" },
      { name: "Careers", href: "#careers" },
      { name: "Blog", href: "#blog" },
      { name: "Press", href: "#press" }
    ],
    services: [
      { name: "Machine Learning", href: "#services" },
      { name: "Azure AI", href: "#services" },
      { name: "Microsoft Fabric", href: "#services" },
      { name: "Consulting", href: "#services" }
    ],
    resources: [
      { name: "Documentation", href: "#docs" },
      { name: "Case Studies", href: "#cases" },
      { name: "Whitepapers", href: "#whitepapers" },
      { name: "Support", href: "#support" }
    ]
  },
  social: {
    linkedin: "https://linkedin.com/company/techauriga",
    twitter: "https://twitter.com/techauriga",
    github: "https://github.com/techauriga",
    youtube: "https://youtube.com/techauriga"
  }
};
